import * as _ from 'lodash';
export default {
  namespaced: true,
  state: {
    currentActiveCategory:{
      title: '',
      id: '',
      location_id: '',
      active: true,
      image: '',
      from_categories: [],
      from_categories_filtered_products: [],
      from_categories_filtered_products_count: 0,
      items: [],
      total_items: 0,
    },

    filterObj: {
      search: '',
      on_sale: 0,
      plant_type: [],
      product_form: [],
      thc: [],
      cbd: [],
      sort: 'default',
      brands: [],
      size: [],
      from_categories: [],
      parent_category: null,
    },
    doSearch: false,
    activeFilter: false,
  },
  getters: {
    currentActiveCategory: state => state.currentActiveCategory,
    searchFilter: state => state.filterObj,
    doSearch: state => state.doSearch,
    activeFilter: state => state.activeFilter
  },
  mutations: {
      currentActiveCategoryMutate (state, data) {
        if(!_.isEmpty(data)){
          state.currentActiveCategory = {
            title: data.title,
            id: data.id,
            location_id: data.location_id,
            active: data.active,
            image: '',
            from_categories: data.from_categories, // pass upto sub cat 
            from_categories_filtered_products: [],
            from_categories_filtered_products_count: 0,
            items: [],
            total_items: 0,
          };
        } 
      }, 
      emptyFilterMutate(state) {
        state.filterObj = {
          search: '',
          on_sale: 0,
          plant_type: [],
          product_form: [],
          thc: [],
          cbd: [],
          sort: 'default',
          brands: [],
          size: [],
          from_categories: [],
          parent_category: null,
        };
      },
      setFilterMutate(state, data) {
        state.filterObj = data
      },
      setSearchFilterEachHeadMutate(state, data) {
        if(state.filterObj.hasOwnProperty(data.key))  {
          state.filterObj[data.key] = data.value;
        }
        
      },
      setDoSearchMutate(state, data) {
        state.doSearch = data
      },
      setActiveFilterMutate(state, data) {
        state.activeFilter = data
      }
  },
  actions: {
    setEmptySearchFilter(context) {
      context.commit('emptyFilterMutate');
    },
    setSearchFilter(context, data) {
      context.commit('setFilterMutate', data);
    },
    setSearchFilterEachHead(context, data) {
      context.commit('setSearchFilterEachHeadMutate', data);
    },
    setDoSearch(context, data) {
      context.commit('setDoSearchMutate', data)
    },
    setActiveFilter(context, data) {
      context.commit('setActiveFilterMutate', data)
    }
  }
}